<template>
  <div>
    <div v-for="(video, index) in items" :key="video.src">
      <div
        v-if="!isMobile"
        class="loader__wrapper"
        :style="videoStyles(video, index)"
      >
        <UiLoader
          :radius="10"
          color="var(--var-blue-100)"
          :circle-width="2"
        />
      </div>
    </div>
    <video
      v-for="(video, index) in items"
      :id="video[0]"
      :key="video[0]"
      :class="videoClass(index)"
      :controls="isMobile"
      autoplay
      autobuffer
      loop
      playsinline
      webkit-playinginline
      muted
      draggable="false"
      @error="handErrorLoadVideo($event, getVideoSrc(video))"
      @click="videoClickHandler(getVideoSrc(video), index)"
    >
      <source
        v-if="videoRange?.includes(index)"
        :src="video.src"
        type="video/mp4"
        :media="'(min-width: 1128px)'"
      />
      <source
        v-if="videoRange?.includes(index)"
        :src="video.srcMobile"
        type="video/mp4"
        :media="'(max-width: 1128px)'"
      />
    </video>
  </div>
</template>

<script setup lang="ts">
import {ref, defineProps} from 'vue';

const props = defineProps<{
  items: any;
  isMobile: boolean;
  isDragging: boolean;
  firstImgWidth: number;
  loadVideoForStart: {[key: string]: boolean};
  videoRange: number[] | null;
}>();

const intervalLoadRef = ref<any>(null);
const handErrorLoadVideo = (e: any, video?: string) => {
  if (video) {
    const brokeVideo: HTMLVideoElement | null =
      document.getElementById(video) as HTMLVideoElement;
    if (brokeVideo) {
      if (intervalLoadRef.value) {
        clearTimeout(intervalLoadRef.value);
        intervalLoadRef.value = null;
      }
      intervalLoadRef.value = setTimeout(async () => {
        brokeVideo.pause();
        brokeVideo.load();
      }, 3000);
    }
  }
};

const isCanControlVideo = ref<{[name: string]: boolean}>({});
const videoClickHandler = async (video: string, index: number) => {
  if (!props.isDragging) {
    // if (!props.isMobile) openInFullSizeHandler(video, index);
    isCanControlVideo.value = {
      [video]: !isCanControlVideo.value[video],
    };
    const videoEl: HTMLVideoElement | null = document.getElementById(
      video,
    ) as HTMLVideoElement;
    if (!isCanControlVideo.value[video]) await videoEl?.play();
  }
};

const getVideoSrc = (video: any) => {
  return props.isMobile ? video?.srcMobile : video.src;
};

const videoStyles = (video: any, index: number) => {
  return {
    left: `calc(${index * props.firstImgWidth + 'px'}`,
    zIndex: props.loadVideoForStart[getVideoSrc(video)] ? 1 : -1,
  };
};

const videoClass = (index: number) => {
  return {
    'gallery-video-loop_first': index === 0,
    'gallery-video-loop': true,
  };
};
</script>

<style lang="scss" scoped>
.loader__wrapper {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

video {
  height: 700px;
  width: calc(100% / 1);
  object-fit: cover;

  @media (max-width: $lg) {
    width: calc(100% / 1);
  }

  @media (max-width: 720px) {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
}

.gallery-video-loop {
  margin-left: 14px;

  &_first {
    margin-left: 0;
  }

  @media (max-width: 720px) {
    margin-left: 10px;
    min-height: 200px;

    &_first {
      margin-left: 0;
    }

    border-radius: 4px;
  }
}
</style>
